// extracted by mini-css-extract-plugin
module.exports = {"styles":"_1fn-EMCBJ1OxT-wEm1TLy"};